// ===============================
// PRELOADER GLOBAL - TrueBalance
// ===============================

// Ocultar al cargar
window.addEventListener("load", () => {
    const preloader = document.getElementById("preloader");
    if (!preloader) return;
    setTimeout(() => preloader.classList.add("hide"), 150);
});

// Mostrar al hacer click en enlaces que sí generan navegación real
document.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    // Si el usuario abre en nueva pestaña → NO preloader
    if (e.ctrlKey || e.metaKey || e.which === 2) return;

    // Si el enlace no navega o abre dropdowns → NO preloader
    if (
        link.classList.contains("side-panel-trigger") ||
        link.classList.contains("primary-menu-trigger") ||
        link.classList.contains("menu-link") ||
        link.classList.contains("canvas-toggle") ||
        link.classList.contains("dropdown-toggle") ||
        link.classList.contains("toggle-item") ||
        link.classList.contains("no-preloader") ||
        link.target === "_blank"
    ) return;

    const href = link.getAttribute("href");
    if (!href || href === "#" || href.startsWith("javascript:")) return;

    // Mostrar preloader
    const preloader = document.getElementById("preloader");
    if (!preloader) return;

    preloader.classList.remove("hide");
});
